var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sent",
    transform: "translate(-52.359 -229.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message_Sent_20px",
    "data-name": "Message Sent_20px",
    transform: "translate(61.087 230.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(1.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M114.7,0l14.487,10.772L143.675,0Z",
    transform: "translate(-114.701)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(0 1.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M112.97,35.077a1.147,1.147,0,0,1-1.369,0l-15.2-11.3V35.231a14.5,14.5,0,0,1,19.1,11.127h11.522a1.147,1.147,0,0,0,1.147-1.147V23.773Z",
    transform: "translate(-96.399 -23.773)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_12",
    "data-name": 12,
    transform: "translate(52.859 245.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M144,292.57A12.57,12.57,0,1,1,156.57,280h0A12.57,12.57,0,0,1,144,292.57Z",
    transform: "translate(-131.43 -267.43)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M148.63,279.206l-3.8-3.8a1.18,1.18,0,0,0-1.67,0l-3.8,3.8a1.2,1.2,0,0,0,0,1.68,1.18,1.18,0,0,0,1.67,0h0l1.78-1.78v4.74a1.181,1.181,0,0,0,2.36,0v-4.74l1.78,1.78a1.2,1.2,0,0,0,1.68,0,1.18,1.18,0,0,0,0-1.67h0Z",
    transform: "translate(-131.43 -267.476)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSentIcon);
export default __webpack_public_path__ + "static/media/message-sent-icon.2b90930c1bf27428239b953205471617.svg";
export { ForwardRef as ReactComponent };